import Vue from 'vue'
import VueRouter from 'vue-router'

import Layout from '../layout/index.vue'

Vue.use(VueRouter)


/**
 * meta.title 页面标题
 * meta.auth 是否需要授权
 */
const routes = [{
  path: '/',
  component: Layout,
  redirect: '/index',
  children: [{
    path: '/index',
    component: () => import('../views/home/index.vue'),
    meta: {
      title: '首页',
      auth: true,
    }
  }, {
    path: '/staff',
    component: () => import('../views/staff/index.vue'),
    meta: {
      title: '员工信息管理',
      auth: true,
    }
  }, {
    path: '/org',
    component: () => import('../views/org/index.vue'),
    meta: {
      title: '机构管理',
      auth: true,
    }
  }, {
    path: '/examination-data',
    component: () => import('../views/examination-data/index.vue'),
    meta: {
      title: '体检数据管理',
      auth: true,
    }
  }, {
    path: '/medical-appointment',
    component: () => import('../views/medical-appointment/index.vue'),
    meta: {
      title: '体检预约查询',
      auth: true,
    }
  }, {
    path: '/medical-report',
    component: () => import('../views/medical-report/index.vue'),
    meta: {
      title: '体检报告',
      auth: true,
    }
  }, {
    path: '/subsidiary',
    component: () => import('../views/subsidiary/index.vue'),
    meta: {
      title: '子公司管理',
      auth: true,
    }
  }]
}, {
  path: '/medical-report/print',
  component: () => import('../views/medical-report/print.vue'),
  meta: {
    title: '体检报告打印',
    auth: true,
  }
}, {
  path: '/login',
  component: () => import('../views/user/login.vue'),
  meta: {
    title: '登录'
  }
}, {
  path: '*',
  component: () => import('../views/error/404.vue'),
  meta: {
    title: '页面不存在'
  }
}]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router